import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdminNavbar from "./Admin/AdminNavbar";

function AddClient() {
  const navigate = useNavigate();
  const [client_id, setClientId] = useState("");
  const [client_name, setClientName] = useState("");
  const [client_country, setClientCountry] = useState("");
  const [client_city, setClientCity] = useState("");
  const [client_contact_number, setClientContactNumber] = useState("");
  const [client_mail_id, setClientMailId] = useState("");
  const [client_contact_person, setClientContactPerson] = useState("");
  const [client_contact_person_mail_id, setClientContactPersonMailId] =
    useState("");
  const [
    client_contact_person_phone_number,
    setClientContactPersonPhoneNumber,
  ] = useState("");
  const [engagement_type, setEngagementType] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/`; // Local Django server endpoint
    const headers = {
      "Content-Type": "application/json",
    };

    const data = {
      client_id,
      client_name,
      client_country,
      client_city,
      client_contact_number,
      client_mail_id,
      client_contact_person,
      client_contact_person_mail_id,
      client_contact_person_phone_number,
      engagement_type,
    };
    // console.log("Request data:", data);
    axios
      .post(apiEndpoint, data, { headers })
      .then((response) => {
        console.log(response.data);
        navigate("/admin_dashboard");
      })
      .catch((error) => {
        // Check if the error response contains a message from the backend
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Failed to Add Client");
        }
        console.error(error);
      });
  };

  return (
    <>
      <AdminNavbar />
      <div className="container py-4">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-6 log">
            <div className="card border border-dark">
              <div
                className="card-header border-dark"
                style={{ background: "#ced4da" }}
              >
                <h3 className="text-center font_header">Add Client Form</h3>
              </div>
              <div className="card-body text-dark">
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="client_id" className="form-label">
                          Client&nbsp;Id
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_id"
                          aria-describedby="emailHelp"
                          value={client_id}
                          onChange={(e) => setClientId(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="client_name">
                            Name
                          </label>
                          <input
                            type="text"
                            id="client_name"
                            className="form-control border-dark text-dark"
                            value={client_name}
                            onChange={(e) => setClientName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label
                            className="form-label"
                            htmlFor="client_country"
                          >
                            Country
                          </label>
                          <input
                            type="text"
                            id="client_country"
                            className="form-control border-dark text-dark"
                            value={client_country}
                            onChange={(e) => setClientCountry(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_mail_id" className="form-label">
                          Mail Id
                        </label>
                        <input
                          type="client_mail_id"
                          className="form-control border-dark text-dark"
                          id="client_mail_id"
                          aria-describedby="emailHelp"
                          value={client_mail_id}
                          onChange={(e) => setClientMailId(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_number"
                          className="form-label"
                        >
                          Contact Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="client_contact_number"
                          aria-describedby="emailHelp"
                          // pattern="(\+91)?[6-9][0-9]{9}"
                          value={client_contact_number}
                          onChange={(e) =>
                            setClientContactNumber(e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_city"
                          aria-describedby="emailHelp"
                          value={client_city}
                          onChange={(e) => setClientCity(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person"
                          className="form-label"
                        >
                          Contact Person
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person"
                          aria-describedby="emailHelp"
                          value={client_contact_person}
                          onChange={(e) =>
                            setClientContactPerson(e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_mail_id"
                          className="form-label"
                        >
                          Contact Person Mail Id
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_mail_id"
                          aria-describedby="emailHelp"
                          value={client_contact_person_mail_id}
                          onChange={(e) =>
                            setClientContactPersonMailId(e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="engagement_type" className="form-label">
                          Engagement Type
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="engagement_type"
                          aria-describedby="emailHelp"
                          value={engagement_type}
                          onChange={(e) => setEngagementType(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_phone_number"
                          className="form-label"
                        >
                          Contact Person Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_phone_number"
                          aria-describedby="emailHelp"
                          value={client_contact_person_phone_number}
                          onChange={(e) =>
                            setClientContactPersonPhoneNumber(e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center py-2">
                    <button
                      type="submit"
                      className="btn me-2 btn-outline-secondary"
                    >
                      Add Client
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() =>
                        (window.location.href = "/admin_dashboard")
                      }
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddClient;
